import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './CookieConsent.css';

const STORAGE_KEY = 'ic_cookie_consent';

export function getConsent() {
  return localStorage.getItem(STORAGE_KEY);
}

export function loadTracking() {
  // GA4
  if (!window.gtagLoaded) {
    const s = document.createElement('script');
    s.src = 'https://www.googletagmanager.com/gtag/js?id=G-RVNKW2F51Q';
    s.async = true;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', 'G-RVNKW2F51Q');
    window.gtagLoaded = true;
  }

  // Meta Pixel
  if (!window.fbqLoaded) {
    (function(f,b,e,v,n,t,s) {
      if(f.fbq) return;
      n=f.fbq=function(){n.callMethod ?
        n.callMethod.apply(n,arguments) : n.queue.push(arguments)};
      if(!f._fbq) f._fbq=n;
      n.push=n; n.loaded=!0; n.version='2.0';
      n.queue=[];
      t=b.createElement(e); t.async=!0;
      t.src=v; s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s);
    }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js'));
    window.fbq('init', '315569869150572');
    window.fbq('track', 'PageView');
    window.fbqLoaded = true;
  }
}

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  // On the /meet chat a bottom bar sits under the Facebook/Instagram in-app
  // browser toolbar and can't be tapped, so it's a centred pop-up there.
  const isPopup = useLocation().pathname.toLowerCase().startsWith('/meet/');

  useEffect(() => {
    const consent = getConsent();
    if (consent === 'accepted') {
      loadTracking();
    } else if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, 'accepted');
    loadTracking();
    setVisible(false);
  };

  const decline = () => {
    localStorage.setItem(STORAGE_KEY, 'declined');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={isPopup ? 'cookie-overlay' : undefined}>
      <div
        className={`cookie-banner${isPopup ? ' cookie-banner--popup' : ''}`}
        role="dialog"
        aria-modal={isPopup || undefined}
        aria-labelledby="cookie-text"
      >
        <p className="cookie-text" id="cookie-text">
          We use cookies to understand how people use Interconnector and improve the experience.
        </p>
        <div className="cookie-buttons">
          <button type="button" className="cookie-btn cookie-accept" onClick={accept}>Accept</button>
          <button type="button" className="cookie-btn cookie-decline" onClick={decline}>Decline</button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
